<template>
  <div class="payment-success" v-loading="contractLoading">
    <h6>支付成功</h6>
    <div class="content">
      <div class="icon">
        <i class="iconfont icon-icon-feiloukong"></i>
      </div>
      <p>支付成功!</p>
      <div class="message">
        <div class="top">
          <i class="iconfont icon-icon-tishi"></i>
          <b>温馨提示:</b>
          <span
            >购买新的资源包，即时生效，有效期12个月。当天新购的资源包无法用于抵扣前一天产生的用量</span
          >
        </div>
        <div class="bottom">
          <div class="label">您可能需要了解:</div>
          <div class="invoice" v-if="false">
            <i class="iconfont icon-icon-kaifapiao"></i>
            <span>开发票</span>
          </div>
          <div class="contract" @click="openContract">
            <i class="iconfont icon-icon-shenqinghetong"></i>
            <span>申请合同</span>
          </div>
        </div>
      </div>

      <div class="btns">
        <el-button type="primary" @click="$router.push('/')"
          >进入控制台</el-button
        >
        <el-button @click="$router.push('/cost-center/my-order')"
          >查看我的订单</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { contractApplication } from '@/utils/api/order'
export default {
  data() {
    return {
      contractLoading: false,
    }
  },
  methods: {
    async openContract() {
      try {
        if (this.contractLoading) return
        this.contractLoading = true
        const params = {
          orderNo: this.$route.params.orderNo || null,
        }
        const res = await contractApplication(params)
        if (res.rspResult.bizCode === 200) {
          const h = this.$createElement
          this.$confirm('', '合同申请', {
            message: h('div', null, [
              h(
                'p',
                {style: 'marginBottom: 10px;'},
                `已将电子合同发送至${res.data?.psnName || ''} ${
                  res.data?.psnMobile || ''
                },请注意查收并进行签署确认。`
              ),
              h('span', {style: 'color: #98a3b7;fontSize: 12px;'}, '电子签名服务提供方为e签宝'),
            ]),
            confirmButtonText: '我知道了',
            center: true,
            showCancelButton: false,
            customClass: 'payment-success-contract-btn',
            closeOnClickModal: false
          })
            .then(() => {
              console.log('点击我知道了')
            })
            .catch(() => {
              console.log('取消合同申请弹框')
            })
        } else if (res.rspResult.bizCode === 20004) {
          // 代表当前用户没有实名认证，弹出询问框
          this.$alert(
            '申请订单合同前，请先完成企业实名认证',
            '请先完成企业实名认证',
            {
              confirmButtonText: '去完成企业实名认证',
              customClass: 'payment-success-alert',
              callback: (action) => {
                if (action === 'confirm') {
                  this.$router.push({
                    name: 'boot-page-real-name',
                    query: {
                      ispayment: 1,
                    },
                  })
                }
              },
            }
          )
        } else if (res.rspResult.bizCode === 5090) {
          this.$message.error('已申请合同，请勿重复申请')
        } else {
          this.$message.error(res.rspResult.message)
        }
        this.contractLoading = false
      } catch (err) {
        console.error(
          '❌ ~ file: payment-success.vue:103 ~ openContract ~ err:',
          err
        )
        this.contractLoading = false
      }
    },
  },
  mounted() {
    console.log('看看有没有被销毁', document.querySelector('.zfb-payment'))
  },
}
</script>

<style lang="scss" scoped>
.payment-success {
  padding-top: 40px;
  > h6 {
    width: 1040px;
    margin: 0 auto;
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    font-size: 16px;
    color: #16181a;
    margin-bottom: 20px;
  }
  > .content {
    width: 1040px;
    margin: 0 auto;
    background: #ffffff;
    padding-top: 108px;
    padding-bottom: 201px;
    .icon {
      margin: 0 auto 20px;
      width: 40px;
      height: 40px;
      background-color: #0bb976;
      display: flex;
      justify-content: center;
      align-items: center;
      i {
        font-size: 60px;
        color: #e6f8f1;
      }
    }
    > p {
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      font-size: 16px;
      color: #16181a;
      letter-spacing: 0;
      text-align: center;
      margin: 16px 0 36px 0;
      height: 16px;
      line-height: 16px;
    }
    .message {
      width: 741px;
      height: 109px;
      background: #f3f5f8;
      border-radius: 4px;
      margin: 0 auto;
      padding: 28px 32px;
      box-sizing: border-box;
      .top {
        display: flex;
        align-items: center;
        margin-bottom: 28px;
        height: 14px;
        > i {
          color: #ff7f2a;
          font-size: 14px;
        }
        > b {
          font-family: SourceHanSansCN-Medium;
          font-weight: 500;
          font-size: 14px;
          color: #ff7f2a;
          letter-spacing: 0;
          margin-left: 5px;
          margin-right: 8px;
          height: 14px;
          line-height: 14px;
        }
        > span {
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #16181a;
          letter-spacing: 0;
          height: 14px;
          line-height: 14px;
        }
      }
      .bottom {
        display: flex;
        align-items: center;
        .label {
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #4f5d78;
          text-align: justify;
          margin-right: 14px;
        }
        .contract,
        .invoice {
          display: flex;
          cursor: pointer;
          align-items: center;
          margin-right: 16px;
          &:hover {
            span {
              color: #066eb7;
            }
          }
          i {
            color: #066eb7;
            font-size: 14px;
            margin-right: 5px;
          }
          span {
            font-family: SourceHanSansCN-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #16181a;
            text-align: justify;
          }
        }
      }
    }
    .btns {
      margin-top: 36px;
      text-align: center;
      button {
        width: 200px;
        height: 40px;
        font-size: 14px;
        font-family: SourceHanSansCN-Medium;
      }
      ::v-deep .el-button:last-child {
        span {
          color: #16181a;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.payment-success-alert {
  padding: 30px;
}
.payment-success-contract-btn {
  width: 566px;
  .el-message-box__close {
    margin-top: 16px;
    margin-right: 17px;
  }
  .el-message-box__title {
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    font-size: 16px;
    color: #16181a;
  }
  .el-message-box__message {
    color: #4f5d78;
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 14px;
  }
  .el-message-box__btns {
    .el-button {
      width: 216px;
      margin-top: 20px;
    }
  }
}
</style>
